export enum GENDERS {
  MALE = "MALE",
  FEMALE = "FEMALE",
  OTHER = "OTHER",
}

export enum SKILLS {
  COMMUNICATION = "COMMUNICATION",
  SOCIAL_MEDIA = "SOCIAL_MEDIA",
  EVENT_ORGANIZATION = "EVENT_ORGANIZATION",
  YOUTH_ENGAGEMENT = "YOUTH_ENGAGEMENT",
  EDUCATION_COACHING = "EDUCATION_COACHING",
  COMMUNITY_OUTREACH = "COMMUNITY_OUTREACH",
}

export enum SKILL_LEVELS {
  EXCEPTIONAL_LEARNER = "EXCEPTIONAL_LEARNER",
  APPROPRIATE_FOR_AGE_LEVEL = "APPROPRIATE_FOR_AGE_LEVEL",
  BOTH = "BOTH",
}

export enum PROFILE_TYPES {
  LEADER = "leader",
  BUILDER = "builder",
}

export enum INDUSTRY_TYPES {
  FOOD_AND_DRINK = "FOOD_AND_DRINK",
  MUSIC = "MUSIC",
  SPORTS = "SPORTS",
  FITNESS = "FITNESS",
  ART = "ART",
  SCIENCE_AND_TECHNOLOGY = "SCIENCE_AND_TECHNOLOGY",
  FILM_AND_MEDIA = "FILM_AND_MEDIA",
  NATURE = "NATURE",
  GROCERY = "GROCERY",
  GENERAL_STORE = "GENERAL_STORE",
  RETAIL_STORE = "RETAIL_STORE",
  FINANCE = "FINANCE",
  MARKETING = "MARKETING",
  EDUCATION = "EDUCATION",
  FIRST_RESPONDER = "FIRST_RESPONDER",
  CONSULTING = "CONSULTING",
  HEALTHCARE = "HEALTHCARE",
  BEAUTY = "BEAUTY",
  HOBBY = "HOBBY",
  HOME_IMPROVEMENT = "HOME_IMPROVEMENT",
  HAIR_NAILS = "HAIR_NAILS",
  PROFESSIONAL_SERVICE = "PROFESSIONAL_SERVICE",
  FACTORY_WAREHOUSE = "FACTORY_WAREHOUSE",
  DENTAL_MEDICAL = "DENTAL_MEDICAL",
  PET_STORE = "PET_STORE",
  LAUNDROMAT = "LAUNDROMAT",
  DRY_CLEANING = "DRY_CLEANING",
  BOOKSTORE_LIBRARY = "BOOKSTORE_LIBRARY",
  SPIRITUAL_FAITH_BASED_CENTRE = "SPIRITUAL_FAITH_BASED_CENTRE",
  CRAFTS = "CRAFTS",
}

export enum DEVICE_TYPES {
  IOS = "IOS",
  ANDROID = "ANDROID",
  WEB = "WEB",
}

export enum NOTIFICATION_PERMISSION {
  DEFAULT = "default",
  DENIED = "denied",
  GRANTED = "granted",
}

export enum AGE_GROUPS {
  GRADES_1_TO_3 = "GRADES_1_TO_3",
  GRADES_4_TO_6 = "GRADES_4_TO_6",
  GRADES_7_TO_8 = "GRADES_7_TO_8",
  GRADES_9_TO_12 = "GRADES_9_TO_12",
}

export enum EVENT_STATUS {
  DRAFT = "DRAFT",
  POSTED = "POSTED",
  CANCELLED = "CANCELLED",
  COMPLETED = "COMPLETED",
  DISABLED = "DISABLED",
  UPCOMING = "UPCOMING",
  PAST = "PAST",
  WISHLIST = "WISHLIST",
  JOINED = "JOINED",
  ALL = "",
}

export enum SUBSCRIPTION_TYPES {
  BASIC = "BASIC",
  TIER_1 = "TIER_1",
  TIER_2 = "TIER_2",
}

export enum LANGUAGES {
  ENGLISH = "English",
  SPANISH = "Spanish",
  FRENCH = "French",
  GERMAN = "German",
  CHINESE = "Chinese",
  OTHER = "Other",
}

export enum BAGDE_TYPES {
  EVENT = "event",
  ACHIEVEMENT = "achievement",
  CORE_CONCEPT = "core_concept",
}

export enum USER_STATUSES {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum TICKET_STATUSES {
  PENDING = "pending",
  APPROVED_WITH_PENALTY = "approved_with_penalty",
  APPROVED_WITHOUT_PENALTY = "approved_without_penalty",
  REJECTED = "rejected",
}

export enum RESOURCE_TAGS {
  GUIDES = "Guides",
  TIPS = "Tips",
  INSTRUCTIONS = "Instructions",
  MORE_INSTRUCTIONS = "More Instructions",
}

export enum SUBSCRIBER_STATUSES {
  ACTIVE = "active",
  EXPERIED = "expired",
}

export enum MESSAGE_TYPES {
  TEXT = "TEXT",
  MEDIA = "MEDIA",
}

export enum SESSION_TYPES {
  ALL = "",
  TRAINING = "training",
  INTRO = "intro",
  REJECTED = "reject",
}

export enum BADGE_ATTRIBUTE_HOST {
  numberOfEventsHosted = "numberOfEventsHosted",
  numberAttendeesJoined = "numberAttendeesJoined",
  memberSinceDays = "memberSinceDays",
  numberCogsEarned = "numberCogsEarned",
}

export enum BADGE_ATTRIBUTE_ATTENDEE {
  numberOfEventsJoined = "numberOfEventsJoined",
  memberSinceDays = "memberSinceDays",
  numberCogsGifted = "numberCogsGifted",
}

export enum BADGE_ATTRIBUTE_AMBASSADOR {
  numberOfEventsJoined = "numberOfEventsJoined",
  numberFamilyHostRegisteredWithRefferalCode = "numberFamilyHostRegisteredWithRefferalCode",
  memberSinceDays = "memberSinceDays",
}

export enum CONDITION_OPTIONS {
  EQUAL = "Equal to (=)",
  GREATER_THAN = "Greater than (>)",
  LESS_THAN = "Less than (<)",
  GREATER_THAN_EQUAL = "Greater than or equal to (≥)",
  LESS_THAN_EQUAL = "Less than or equal to (≤)",
}

export enum ENGAGEMENT_LEVELS {
  MINIMUM_5_6_HOURS_PER_MONTH = "Minimum (5-6 hours/month)",
  MODERATE_10_15_HOURS_PER_MONTH = "Moderate (10-15 hours/month)",
  HIGH_15_PLUS_HOURS_PER_MONTH = "High (15+ hours/month)",
}

export enum CITY_OPTIONS {
  NewYork = "New York",
  LosAngeles = "Los Angeles",
  Chicago = "Chicago",
  Houston = "Houston",
  Phoenix = "Phoenix",
  Philadelphia = "Philadelphia",
  SanAntonio = "San Antonio",
  SanDiego = "San Diego",
  Dallas = "Dallas",
  SanJose = "San Jose",
  Austin = "Austin",
  Jacksonville = "Jacksonville",
  FortWorth = "Fort Worth",
  Columbus = "Columbus",
  Charlotte = "Charlotte",
  SanFrancisco = "San Francisco",
  Indianapolis = "Indianapolis",
  Seattle = "Seattle",
  Denver = "Denver",
  Washington = "Washington",
  Boston = "Boston",
  Nashville = "Nashville",
  ElPaso = "El Paso",
  Detroit = "Detroit",
  OklahomaCity = "Oklahoma City",
  Portland = "Portland",
  LasVegas = "Las Vegas",
  Memphis = "Memphis",
  Louisville = "Louisville",
  Baltimore = "Baltimore",
}
